<template lang="pug">
  div
    page_header(title="Event Days", subhead="Edit")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "eventday.index", params:{id:id}}')
        i.feather-arrow-left
        | Back

    .row
      .col-sm-6
        form.card(@submit.prevent="submit" :class="sending?'loading':''")
          .card-body.border-bottom.p-5
            .row
              .col-sm-12

                .mb-3
                  label.form-label Startup
                  multiselect(v-model="form.startup",tag-placeholder="Startup",placeholder="Search or add a startup",:options="startups", :multiple="false", :taggable="false", label="name")
                  form_error(:errors="errors?errors['startup']:[]")

                .mb-3
                  label.form-label Representative
                  multiselect(v-model="form.representative",tag-placeholder="Representative",placeholder="Search or add a representative",:options="representatives", :multiple="false", :taggable="false", label="name")
                  form_error(:errors="errors?errors['representative']:[]")

                form_input(type="text" name="link" label="Conference Link" placeholder="Conference Link" v-model="form.conference_link" :required="true")  

                form_select(name="status" label="status" placeholder="status" v-model="form.status" :options="['active','inactive']" :required="true")
                
                form_select(name="flag" label="flag" placeholder="flag" v-model="form.flag" :options="['noflag','covid']" :required="true")
                
            .d-flex.align-items-center
              //- a.btn.btn-link Back
              loadingBtn.ml-auto(type="submit" :disabled='sending') Save

  
      

</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import form_input from '@/components/formInput'
import loadingBtn from '@/components/loadingBtn'
import form_select from '@/components/formSelect'
import formError from '@/components/formErrors';

import Multiselect from 'vue-multiselect'

import 'vue-multiselect/dist/vue-multiselect.min.css';

import { mapActions, mapState } from 'vuex'
export default {
  name: 'Products',
  props: ['id'],
  components: {
    page_header: page_header,
    form_input,
    form_select,
    loadingBtn,
    Multiselect,
    form_error: formError,
  },
  data(){
    return {
      startups: [],
      representatives: [],
      form: {
        representative: {},
        startup: {},
        conference_link: '',
        status: '',
        eventday_id: this.id,
      },
      blank: {
        representative: {},
        startup: {},
        conference_link: '',
        status: '',
        eventday_id: this.id,
      }
    }
  },
  computed: {
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    resetForm(){
      this.form = JSON.parse(JSON.stringify(this.blank));
    },
    submit(){
      var vm = this;
      this.call({_vm:this, endpoint: 'admin/stall', method: 'POST', data: this.form}).then(()=>{
        vm.resetForm();
      })
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    var vm = this;
    this.call({_vm: vm, endpoint: `admin/stall/create`, method: 'GET'}).then(async (response)=>{
      vm.startups = response.startups;
      vm.representatives = response.representatives;
    })
  }
}
</script>
